export default {
  telaInicial: `Tela inicial`,
  parametros: `Parâmetros`,
  operacional: `Operacional`,
  gerenciarUsuarios: `Gerenciar usuários`,
  migracaoDados: `Migração de dados`,
  estabelecimentos: `Estabelecimentos`,
  planosPacotes: `Planos e Pacotes`,
  dispositivos: `Dispositivos`,
  bancos: `Bancos`,
  cessionarios: `Cessionários`,
  distribuidores: `Distribuidores`,
  usuarios: `Usuários`,
  permissoes: `Permissões`,
  tokensAcesso: `Tokens de acesso`,
  //assistenteImportacao: `Assist. de importação`,
  importarExportar: `Importar / Exportar`,
  credenciamento: `Credenciamento`,
  consultar: `Consultar`,
  mcc: `MCC / CNAE`,
  splitPagamentos: `Split de pagamentos`,
  gruposEconomicos: `Economic Group`,
  planosTaxas: `Planos de taxas`,
  planosMensalidades: `Planos de mensalidades`,
  gerenciar: `Gerenciar`,
  fabricantes: `Fabricantes`,
  modelos: `Modelos`,
  chip: `CHIP SIM`,
  relatorios: `Relatórios`,
  solicitar: `Solicitar`,
  antecipacoes: `Antecipações`,
  conciliacao: `Conciliação`,
  visaoGeral: `Visão geral`,
  transacoesPendentes: `Pending Confirmation`,
  movimentoAdquirente: `Movimento adquirente`,
  notificacoesPush: `Notificações Push`,
  vendasTransacoes: `Vendas / Transações`,
  naoIntegradas: `Não Integradas`,
  preAutorizacao: `Pré autorização`,
  cancelamentos: `Cancelamentos`,
  chargebacks: `Chargebacks`,
  cartaoInternacional: `Cartão internacional`,
  boletoBancario: `Boleto bancário`,
  financeiro: `Financeiro`,
  contasPagar: `Contas à pagar`,
  novaAntecipacao: `Nova antecipação`,
  listarAntecipacao: `Listar Solicitações`,
  fluxoCaixa: `Fluxo de caixa`,
  lancamentos: `Lançamentos`,
  notaFiscal: `RPS`,
  regulatorios: `Regulatórios`,
  informeRendimento: `Informe de rendimento`,
  docSP: `DOC - Prefeitura SP`,
  registradoras: `Registradoras`,
  consultarAgenda: `Consultar agenda`,
  registroArranjo: `Registro por arranjo`,
  contestacao: `Contestação`,
  contratos: `Contratos`,
  posContratada: `Pós contratada`,
  transmissoes: `Transmissões`,
  suporte: `Suporte`,
  transacoesEDI: `Transações EDI`,
  faturamento: `Faturamento`,
  aluguelPOS: `Mensalidades`,
  compliance: `Compliance`,
  elo: `Elo`,
  ofac: `Ofac`,
  unidadeRecebivel: `Consultar URs`,
  consultaOpt: `Opt-in / Opt-out`,
  registradoraConciliacao: `Conciliação`
};
